import type { Message, UserId } from '@cyphex/types';
/* Deep imports for the same reason as the rest of the rail — see CallChatThread. */
import { ForwardDialog } from '@/features/chat/components/dialogs/ForwardDialog';
import { useConversations } from '@/features/chat/hooks/useConversations';

export interface CallForwardDialogProps {
  message: Message;
  meId: UserId | null;
  onClose: () => void;
}

/**
 * Forward targets for the in-call rail.
 *
 * A wrapper exists purely so the conversation LIST is fetched when somebody
 * actually forwards something. `ThreadPane` gets that list for free from the
 * chat page around it; the rail has no page, and paging every conversation on
 * the off-chance is not worth paying for on every call that opens chat.
 */
export function CallForwardDialog({ message, meId, onClose }: CallForwardDialogProps) {
  const { flat } = useConversations('all', '');
  return <ForwardDialog message={message} conversations={flat} meId={meId} onClose={onClose} />;
}
